module.exports = __webpack_public_path__ + "static/media/popup-survey.eaef0c6c.png";